import api from './api';

/** Bulk shift runs reconcile per batch; allow ~90s per batch, min 3 min, max 15 min. */
function bulkScheduleShiftTimeout(payload) {
  const count = payload?.batch_ids?.length || 1;
  return Math.min(900000, Math.max(180000, count * 90000));
}

export const batchesAPI = {
  // Get all batches with optional filters
  getAll: (params = {}) => {
    return api.get('/api/batches', { params });
  },

  // Get a specific batch by ID (optional params: sessionDate=YYYY-MM-DD for historical class lookup)
  getById: (id, params = {}) => {
    return api.get(`/api/batches/${id}`, { params });
  },

  getNextName: (country) => {
    return api.get('/api/batches/next-name', { params: { country } });
  },

  // Create a new batch
  create: (batchData) => {
    return api.post('/api/batches', batchData);
  },

  // Update a batch
  update: (id, batchData) => {
    return api.put(`/api/batches/${id}`, batchData);
  },

  // Delete a batch
  delete: (id) => {
    return api.delete(`/api/batches/${id}`);
  },

  // Get batch statistics
  getStats: () => {
    return api.get('/api/batches/stats');
  },

  // Update batch schedules
  updateSchedules: (id, schedules) => {
    return api.post(`/api/batches/${id}/schedules`, schedules);
  },

  previewBulkScheduleShift: (payload) => {
    return api.post('/api/batches/bulk-schedules/preview', payload, {
      timeout: bulkScheduleShiftTimeout(payload),
    });
  },

  applyBulkScheduleShift: (payload) => {
    return api.post('/api/batches/bulk-schedules/apply', payload, {
      timeout: bulkScheduleShiftTimeout(payload),
    });
  },

  // Get available teachers for batch schedules (exact + partial + unavailable)
  getAvailableTeachersForSchedules: (schedules, options = {}) => {
    return api.post('/api/batches/available-teachers-for-schedules', {
      schedules,
      ...(options.excludeBatchId ? { exclude_batch_id: options.excludeBatchId } : {}),
      ...(options.findClassSlotsInWindow ? { find_class_slots_in_window: true } : {}),
    });
  },

  // Get teachers with batch counts filtered by batch filters
  getTeachersWithCounts: (params = {}) => {
    return api.get('/api/batches/teachers-with-counts', { params });
  },

  getEnrollmentOptions: (params = {}) => {
    return api.get('/api/batches/enrollment-options', { params });
  },

  getStudentsPreview: (batchId, params = {}) => api.get(`/api/batches/${batchId}/students-preview`, { params }),

  getStudents: (batchId) => api.get(`/api/batches/${batchId}/students`),

  getActivePause: (batchId) => api.get(`/api/batches/${batchId}/pause`),

  getPauseStudents: (batchId) => api.get(`/api/batches/${batchId}/pause/students`),

  createPause: (batchId, data) => api.post(`/api/batches/${batchId}/pause`, data),

  endPause: (batchId) => api.patch(`/api/batches/${batchId}/pause/end`),
};

export default batchesAPI; 